import ResourceSection from './ResourceSection'

export default ResourceSection
